// extracted by mini-css-extract-plugin
module.exports = {"ariaSkipLinksContainer":"xa-z"};